import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {editReservation as editReservationAPI} from '../../../services/reservations'
import fixture from '../../../fixtures/reservations/get-configuration.json'

export async function editReservation(dispatch, reservationData) {
  try {
    dispatch({type: PENDING})
    let response = await editReservationAPI(reservationData)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Get Reservation Configuration Failed: ${reservationData}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}

export async function resetReservation(dispatch) {
  dispatch({type: RESET})
}
